/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BottomBar_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SiteNav_viewer" | "Contact1stdibsLink_viewer">;
    readonly " $refType": "BottomBar_viewer";
};
export type BottomBar_viewer$data = BottomBar_viewer;
export type BottomBar_viewer$key = {
    readonly " $data"?: BottomBar_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BottomBar_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BottomBar_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SiteNav_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Contact1stdibsLink_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'd544ac48813350e108cbeb3b69497770';
export default node;
